import { render } from "./GenericChart.vue?vue&type=template&id=5577237f&ts=true"
import script from "./GenericChart.vue?vue&type=script&lang=ts"
export * from "./GenericChart.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mitliv/wp-content/themes/wp-mitliv-theme/resources/views/backend/statistics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__